import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.scss']
})
export class AppDownloadComponent implements OnChanges {

	@Input() data: any = {};
	@Input() eapUrl: string = '';
	@Input() eapPhone: string = '';
	@Input() ctaType: string = '';
	@Input() groupCode: string = '';
	@Input() groupCodeLabel: string = '';

	public registerText: string = 'Register';
	public headlineText: string = 'Support anywhere.';
	public scanText: string = 'Scan to download';
	public defaultAppText: string = '';
	public defaultAppTextNoScan: string = '';

	constructor(
		private translationService: TranslationService,
		private siteService: SiteService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['data']) {
			this.updateTexts();
		}
	}

	private updateTexts(): void {
		const hasScan = !!this.data?.['QR Code'];
		const scanPrefix = hasScan ? 'Scan the QR code or d' : 'D';
		this.defaultAppText = `${scanPrefix}ownload the app from your app store to access your EAP resources \u2013 always available when you or your family needs it.`;
		this.defaultAppTextNoScan = `Download the app from your app store to access your EAP resources \u2013 always available when you or your family needs it.`;
		this.registerText = this.ctaType === 'Call EAP' ? 'Call to Register' : 'Register';

		const currentLang = this.translationService.getCurrentLanguage();
		if (currentLang === 'en') return;

		const employer = this.siteService.onEmployerSet.getValue();
		if (!employer) return;

		const items = [
			{ id: 'app-download-register', text: this.registerText },
			{ id: 'app-download-headline', text: 'Support anywhere.' },
			{ id: 'app-download-scan', text: 'Scan to download' },
			{ id: 'app-download-default-text', text: this.defaultAppText },
			{ id: 'app-download-default-text-noscan', text: this.defaultAppTextNoScan }
		];

		this.translationService.translatePage(employer.employerID, '/home', items).subscribe(translations => {
			this.registerText = translations['app-download-register'] || this.registerText;
			this.headlineText = translations['app-download-headline'] || this.headlineText;
			this.scanText = translations['app-download-scan'] || this.scanText;
			this.defaultAppText = translations['app-download-default-text'] || this.defaultAppText;
			this.defaultAppTextNoScan = translations['app-download-default-text-noscan'] || this.defaultAppTextNoScan;
		});
	}

	sanitizePhone(phone: string): string {
		if (!phone) return '';
		return phone.replace(/\D/g, '');
	}
}
